import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "services/token-provider";
import { LocalStorageKeys, RtkTagTypes } from "types/enums";
export const mainUrl = process.env.REACT_APP_API_URL;
export const rubyApiBaseUrl = process.env.REACT_APP_RUBY_API_URL;

const baseUrl = `${mainUrl}api`;

export const apiService = createApi({
  reducerPath: "API",
  baseQuery: async (args, api, extraOptions) => {
    const baseFetch = fetchBaseQuery({
      baseUrl,
      prepareHeaders: async (headers) => {
        const token = await getToken();
        if (token) {
          headers.set("authorization", `Bearer ${token}`);
        }
        const orgUserId = localStorage.getItem(
          LocalStorageKeys.OrganizationUserId
        );
        if (orgUserId) {
          headers.set("X-Org-User-Id", orgUserId);
        }

        return headers;
      },
    });

    // Make the API call
    const result = await baseFetch(args, api, extraOptions);

    return result;
  },
  endpoints: () => ({}),
  keepUnusedDataFor: 120,
  tagTypes: [...Object.values(RtkTagTypes)],
});
